import axios from 'axios';

function postRequestOptions(body) {
	//var jwt = { token: getCookie('MyToken') };
	let jwt = JSON.parse(localStorage.getItem('MyToken'));
	let requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': 'Bearer ' + jwt },
		body: JSON.stringify(body)
	};
	return requestOptions;
}

function getRequestOptions() {
	let jwt = JSON.parse(localStorage.getItem('MyToken'));

	let requestOptions = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': 'Bearer ' + jwt }
	};
	return requestOptions;
}

// Axios helper functions
function getAxiosConfig() {
	let jwt = JSON.parse(localStorage.getItem('MyToken'));
	return {
		headers: { 
			'Accept': 'application/json', 
			'Authorization': 'Bearer ' + jwt 
		}
	};
}

function getAxiosConfigWithContentType(contentType = 'application/json') {
	let jwt = JSON.parse(localStorage.getItem('MyToken'));
	return {
		headers: { 
			'Content-Type': contentType,
			'Accept': 'application/json', 
			'Authorization': 'Bearer ' + jwt 
		}
	};
}

export { postRequestOptions, getRequestOptions, getAxiosConfig, getAxiosConfigWithContentType };

